// extracted by mini-css-extract-plugin
module.exports = {"stepper":"_2y5IlrrwDE","vertical":"_1rMGdNVoAM"};
    if(module.hot) {
      // 1597843273115
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  